import { useToast } from '@chakra-ui/react';
import { TRPCClientError } from '@trpc/client';
import { useCallback } from 'react';
import { z } from 'zod';

// Zod to find Zod
const zodError = z.array(
  z.object({
    code: z.string(),
    message: z.string(),
    path: z.array(z.coerce.string()),
  }),
);

const tryToHandleTRPCZodError = (error: any) => {
  if (error instanceof TRPCClientError) {
    try {
      const parsed = zodError.parse(JSON.parse(error.message));
      return parsed.map((x) => `${x.path?.join('.')}: ${x.message}`)?.join(', ');
    } catch (e) {
      return;
    }
  }
  return;
};

export const useError = () => {
  const toast = useToast();

  const handleError = useCallback(
    (error?: any) => {
      const message = error?.response?.data?.detail || error?.response?.data?.message || error?.message || error;

      console.error('useError():', error);

      toast({
        title: 'Something went wrong',
        description: tryToHandleTRPCZodError(error) ?? message,
        status: 'error',
        duration: 6000,
        isClosable: true,
      });
    },
    [toast],
  );

  return {
    handleError,
  };
};
